/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Relaunch_Storefront_ConfirmInputs */

const en_relaunch_storefront_confirm = /** @type {(inputs: Relaunch_Storefront_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relaunch your storefront now?`)
};

const id_relaunch_storefront_confirm = /** @type {(inputs: Relaunch_Storefront_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luncurkan kembali etalase Anda sekarang?`)
};

/** @type {(inputs: Relaunch_Storefront_ConfirmInputs) => LocalizedString} */
const es_relaunch_storefront_confirm = en_relaunch_storefront_confirm;

/** @type {(inputs: Relaunch_Storefront_ConfirmInputs) => LocalizedString} */
const fr_relaunch_storefront_confirm = en_relaunch_storefront_confirm;

/** @type {(inputs: Relaunch_Storefront_ConfirmInputs) => LocalizedString} */
const de_relaunch_storefront_confirm = en_relaunch_storefront_confirm;

/** @type {(inputs: Relaunch_Storefront_ConfirmInputs) => LocalizedString} */
const ja_relaunch_storefront_confirm = en_relaunch_storefront_confirm;

/** @type {(inputs: Relaunch_Storefront_ConfirmInputs) => LocalizedString} */
const zh_relaunch_storefront_confirm = en_relaunch_storefront_confirm;

/** @type {(inputs: Relaunch_Storefront_ConfirmInputs) => LocalizedString} */
const ar_relaunch_storefront_confirm = en_relaunch_storefront_confirm;

/** @type {(inputs: Relaunch_Storefront_ConfirmInputs) => LocalizedString} */
const it_relaunch_storefront_confirm = en_relaunch_storefront_confirm;

/** @type {(inputs: Relaunch_Storefront_ConfirmInputs) => LocalizedString} */
const ru_relaunch_storefront_confirm = en_relaunch_storefront_confirm;

/** @type {(inputs: Relaunch_Storefront_ConfirmInputs) => LocalizedString} */
const pt_relaunch_storefront_confirm = en_relaunch_storefront_confirm;

/** @type {(inputs: Relaunch_Storefront_ConfirmInputs) => LocalizedString} */
const ko_relaunch_storefront_confirm = en_relaunch_storefront_confirm;

/**
* | output |
* | --- |
* | "Relaunch your storefront now?" |
*
* @param {Relaunch_Storefront_ConfirmInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const relaunch_storefront_confirm = /** @type {((inputs?: Relaunch_Storefront_ConfirmInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relaunch_Storefront_ConfirmInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relaunch_storefront_confirm(inputs)
	if (locale === "es") return es_relaunch_storefront_confirm(inputs)
	if (locale === "fr") return fr_relaunch_storefront_confirm(inputs)
	if (locale === "de") return de_relaunch_storefront_confirm(inputs)
	if (locale === "ja") return ja_relaunch_storefront_confirm(inputs)
	if (locale === "zh") return zh_relaunch_storefront_confirm(inputs)
	if (locale === "ar") return ar_relaunch_storefront_confirm(inputs)
	if (locale === "id") return id_relaunch_storefront_confirm(inputs)
	if (locale === "it") return it_relaunch_storefront_confirm(inputs)
	if (locale === "ru") return ru_relaunch_storefront_confirm(inputs)
	if (locale === "pt") return pt_relaunch_storefront_confirm(inputs)
	return ko_relaunch_storefront_confirm(inputs)
});